import { navigate } from "../lib/navigation";

interface WebGLFallbackProps {
  reason: "unsupported" | "render-error";
}

export function WebGLFallback({ reason }: WebGLFallbackProps) {
  return (
    <div className="fallback-world">
      <div className="fallback-field" aria-hidden="true">
        <span className="fallback-shape fallback-shape-a" />
        <span className="fallback-shape fallback-shape-b" />
        <span className="fallback-shape fallback-shape-c" />
      </div>
      <div className="fallback-copy">
        <p className="signal-label">Static scene</p>
        <h2>The ideas still connect without WebGL.</h2>
        <p>
          {reason === "unsupported"
            ? "This browser cannot run the interactive world, so the same portfolio is available through its semantic index."
            : "The interactive renderer stopped unexpectedly. The readable portfolio remains available while the scene is offline."}
        </p>
        <button type="button" onClick={() => navigate("/index")}>
          Open the portfolio index
        </button>
      </div>
    </div>
  );
}

